// import React, { useState } from "react";

// interface CarouselProps {
//   items: React.ReactNode[];
//   autoScroll?: boolean;
//   scrollInterval?: number;
// }

// const Carousel: React.FC<CarouselProps> = ({
//   items,
//   autoScroll = false,
//   scrollInterval = 3000,
// }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const hasMultipleItems = items.length > 1;

//   const handleNavigation = (index: number) => {
//     setCurrentIndex(index);
//   };

//   React.useEffect(() => {
//     if (!autoScroll || !hasMultipleItems) return;
//     const interval = setInterval(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
//     }, scrollInterval);
//     return () => clearInterval(interval);
//   }, [autoScroll, scrollInterval, items.length, hasMultipleItems]);

//   return (
//     <div className="relative w-full overflow-hidden">
//       {/* Items */}
//       <div
//         className={`flex ${hasMultipleItems ? "transition-transform duration-500 ease-in-out" : ""}`}
//         style={{ transform: hasMultipleItems ? `translateX(-${currentIndex * 100}%)` : undefined }}
//       >
//         {items.map((item, index) => (
//           <div
//             key={index}
//             className="flex-shrink-0 w-full px-4"
//           >
//             {item}
//           </div>
//         ))}
//       </div>

//       {/* Navigation Container - Only show if multiple items exist */}
//       {hasMultipleItems && (
//         <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex items-center gap-4">
//           {/* Previous Button */}
//           <button
//             onClick={() =>
//               setCurrentIndex(
//                 currentIndex === 0 ? items.length - 1 : currentIndex - 1
//               )
//             }
//             className="bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-full p-2"
//           >
//             &#8592;
//           </button>

//           {/* Navigation Dots */}
//           <div className="flex space-x-2">
//             {items.map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => handleNavigation(index)}
//                 className={`w-3 h-3 rounded-full ${
//                   index === currentIndex
//                     ? "bg-blue-500"
//                     : "bg-gray-300"
//                 }`}
//               />
//             ))}
//           </div>

//           {/* Next Button */}
//           <button
//             onClick={() =>
//               setCurrentIndex((currentIndex + 1) % items.length)
//             }
//             className="bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-full p-2"
//           >
//             &#8594;
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Carousel;

import React, { useState } from "react";
import SecureImage from "../BucketImage/Image";
import { nextArrow, previous } from "../../common/svg";

interface CarouselProps {
  items: React.ReactNode[];
  autoScroll?: boolean;
  scrollInterval?: number;
}

const Carousel: React.FC<CarouselProps> = ({
  items,
  autoScroll = false,
  scrollInterval = 3000,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const hasMultipleItems = items.length > 1;

  const handleNavigation = (index: number) => {
    setCurrentIndex(index);
  };

  React.useEffect(() => {
    if (!autoScroll || !hasMultipleItems) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
    }, scrollInterval);
    return () => clearInterval(interval);
  }, [autoScroll, scrollInterval, items.length, hasMultipleItems]);

  return (
    <div className="relative w-full overflow-hidden h-full">
      {/* Items */}
      <div
        className={`flex ${hasMultipleItems ? "transition-transform duration-500 ease-in-out" : ""}`}
        style={{ transform: hasMultipleItems ? `translateX(-${currentIndex * 100}%)` : undefined }}
      >
        {items.map((item, index) => (
          <div
            key={index}
            className="flex-shrink-0 w-full mb-10"
          >
            {item}
          </div>
        ))}
      </div>

      {/* Navigation Container - Only show if multiple items exist */}
      {hasMultipleItems && (
        <div className="absolute bottom-0  left-1/2 transform -translate-x-1/2 flex items-center gap-4">
          {/* Previous Button */}
          <button
          style={{ width: "15px", height: "15px" }}
            onClick={() =>
              setCurrentIndex(
                currentIndex === 0 ? items.length - 1 : currentIndex - 1
              )
            }
            className="bg-[#444FBD] flex justify-center items-center hover:bg-gray-300 text-gray-700 rounded-full "
          >
            <SecureImage
                      fileKey={previous}
                      alt="Vehicle"
                      width="6.66px"
                    />
          </button>

          {/* Navigation Dots */}
          <div className="flex space-x-2">
            {items.map((_, index) => (
              <button
                key={index}
                onClick={() => handleNavigation(index)}
                className={`w-2 h-2 rounded-full ${
                  index === currentIndex
                    ? "bg-[#444FBD]"
                    : "bg-gray-300"
                }`}
              />
            ))}
          </div>

          {/* Next Button */}
          <button
          style={{ width: "15px", height: "15px" }}
            onClick={() =>
              setCurrentIndex(
                currentIndex === 0 ? items.length - 1 : currentIndex - 1
              )
            }
            className="bg-[#444FBD] flex justify-center items-center hover:bg-gray-300 text-gray-700 rounded-full "
          >
            <SecureImage
                      fileKey={nextArrow}
                      alt="Vehicle"
                      width="6.66px"
                    />
          </button>
        </div>
      )}
    </div>
  );
};

export default Carousel;